import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../utils/ThemeContext';
import ThemeToggle from './ThemeToggle';
import logoLight from '../assets/images/logo-light.svg';
import logoDark from '../assets/images/logo-dark.svg';
import '../styling/Header.css';

const Header: React.FC = () => {
  const { theme } = useTheme();
  
  return (
    <header className="header">
      <div className="nav-container">
        <Link to="/">
          <img 
            className="logo" 
            src={theme === 'light' ? logoLight : logoDark} 
            alt="Travelisk" 
          />
        </Link>
        
        <nav className="nav">
          <Link className="nav-link" to="/">Home</Link>
          <Link className="nav-link" to="/packages">Packages</Link>
          <Link className="nav-link" to="/about">About</Link>
          <Link className="nav-link" to="/contact">Contact</Link>
        </nav>
        
        <ThemeToggle />
      </div>
    </header>
  );
};

export default Header; 